module.exports = __webpack_public_path__ + "img/unimol.f4603e7f.png";